import AddCompany from "../pages/utility/company/add";
import ListCompany from "../pages/utility/company/list";
import EditCompany from "../pages/utility/company/edit";

import AddUser from "../pages/utility/user/add";
import ListUser from "../pages/utility/user/list";
import EditUser from "../pages/utility/user/edit";

import UserPermissions from "../pages/utility/userPermission/index";
import CopyUserPermissions from "../pages/utility/copyUserPermission/index";

import AddFinancialYear from "../pages/utility/financialYear/add";
import ListFinancialYear from "../pages/utility/financialYear/list";
import EditFinancialYear from "../pages/utility/financialYear/edit";

export const utilityRoutes = [
  {
    path: `/utility/company/add`,
    Component: <AddCompany />,
    permission: "company.add"
  },
  {
    path: `/utility/company/list`,
    Component: <ListCompany />,
    permission: "company.list"
  },
  {
    path: `/utility/company/edit/:id`,
    Component: <EditCompany />,
    permission: "company.edit"
  },
  // user
  {
    path: `/utility/user/add`,
    Component: <AddUser />,
    permission: "usermaster.add"
  },
  {
    path: `/utility/user/list`,
    Component: <ListUser />,
    permission: "usermaster.list"
  },
  {
    path: `/utility/user/edit/:id`,
    Component: <EditUser />,
    permission: "usermaster.edit"
  },

  // user permission
  {
    path: `/utility/user-permission`,
    Component: <UserPermissions />,
    permission: "userpermission"
  },

  {
    path: `/utility/copy-user-permission`,
    Component: <CopyUserPermissions />,
    permission: "copyuserpermission"
  },

  // financial year
  {
    path: `/utility/financial-year/add`,
    Component: <AddFinancialYear />,
    permission: "financialyear.add"
  },
  {
    path: `/utility/financial-year/list`,
    Component: <ListFinancialYear />,
    permission: "financialyear.list"
  },
  {
    path: `/utility/financial-year/edit/:id`,
    Component: <EditFinancialYear />,
    permission: "financialyear.edit"
  }
];
